var map = {
	"./": [
		1867,
		9
	],
	"./ar": [
		7333,
		3
	],
	"./ar.json": [
		7333,
		3
	],
	"./en": [
		389,
		3
	],
	"./en.json": [
		389,
		3
	],
	"./es": [
		8302,
		3
	],
	"./es.json": [
		8302,
		3
	],
	"./fr": [
		5222,
		3
	],
	"./fr.json": [
		5222,
		3
	],
	"./index": [
		1867,
		9
	],
	"./index.ts": [
		1867,
		9
	],
	"./zh": [
		9872,
		3
	],
	"./zh.json": [
		9872,
		3
	]
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var ids = map[req], id = ids[0];
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3687;
module.exports = webpackAsyncContext;